import React from 'react';

const TimelineConnector = ({ show }) => {
    if (!show) return null;

    return (
        <div className="note-connector d-flex justify-content-center my-3">
            <div className="connector-line">
                <div className="connector-icon">
                    <i className="fas fa-circle text-primary"></i>
                </div>
            </div>
        </div>
    );
};

export default TimelineConnector;
